export var RowType;
(function (RowType) {
  RowType["SM_ONE_LINE_ROW"] = "sm-1-row";
  RowType["SM_TWO_ROW"] = "sm-2-row";
})(RowType || (RowType = {}));